import React, { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEOROICalculator from '@/components/SEOROICalculator';
import { updateMetaTags } from '@/utils/seoCore';
import { generateHreflangLinks, updateHreflangLinks } from '@/lib/swissHreflang';
import { generateOrganizationSchema, injectSchema } from '@/lib/swissSchema';
import { SwissLanguage } from '@/lib/swissI18n';

const SEOROICalculatorPage = () => {
  const { currentLanguage: language } = useLanguage();

  useEffect(() => {
    // Update meta tags
    updateMetaTags({
      title: 'SEO ROI Rechner Schweiz | Berechnen Sie Ihren SEO Return on Investment',
      description: 'Kostenloses Tool zur Berechnung Ihres SEO ROI. Erfahren Sie, wie viel zusätzlichen Umsatz SEO für Ihr Schweizer Unternehmen generieren kann. Jetzt kostenlos berechnen.',
      keywords: 'SEO ROI Rechner, SEO Return on Investment, SEO Kosten Schweiz, SEO Umsatz berechnen, Online Marketing ROI',
      canonicalUrl: 'https://www.future-level.ch/de/seo-roi-rechner',
      ogImage: 'https://www.future-level.ch/og-seo-roi-calculator.jpg'
    });

    // Update hreflang links
    const hreflangLinks = generateHreflangLinks({
      currentLanguage: language as SwissLanguage,
      currentPath: '/seo-roi-rechner',
      availableLanguages: ['de'] as SwissLanguage[]
    });
    updateHreflangLinks(hreflangLinks);

    // Add organization schema
    const organizationSchema = generateOrganizationSchema({ language: language as SwissLanguage });
    injectSchema(organizationSchema);

    // Add WebApplication schema for the calculator
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "SEO ROI Rechner",
      "description": "Berechnen Sie den Return on Investment Ihrer SEO-Investition für Schweizer Unternehmen",
      "url": "https://www.future-level.ch/de/seo-roi-rechner",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web Browser",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CHF",
        "availability": "https://schema.org/InStock"
      },
      "provider": {
        "@type": "Organization",
        "name": "Future Level",
        "url": "https://www.future-level.ch"
      }
    };
    injectSchema(calculatorSchema);

  }, [language]);

  return (
    <div className="min-h-screen">
      <Header />
      <SEOROICalculator />
      <Footer />
    </div>
  );
};

export default SEOROICalculatorPage;